export const FETCH_BLOG_POSTS_STARTED = "fetch_blog-posts_started";
export const FETCH_BLOG_POSTS_SUCCESS = "fetch_blog-posts_success";
export const FETCH_BLOG_POSTS_FAILURE = "fetch_blog-posts_failure";

export const FETCH_SINGLE_BLOG_POST_STARTED = "fetch_single_blog-post_started";
export const FETCH_SINGLE_BLOG_POST_SUCCESS = "fetch_single_blog-post_success";
export const FETCH_SINGLE_BLOG_POST_FAILURE = "fetch_single_blog-post_failure";